import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import {
  Layout,
  List,
  Menu,
  Popover,
  Typography,
  Avatar,
  Col,
  Row,
  Select,
  Spin,
  notification,
} from 'antd';
import moment from 'moment';
import { logoutUser, setCommentOpened, setPoOpenChat, setOperators } from '../actions';
import { getNotificationList } from '../services';
import notificationIcon from '../images/NavbarAndSidebar/Notification.svg';
import logoutIcon from '../images/NavbarAndSidebar/Logout.svg';
import PubNub from 'pubnub';
import config from '../../config';
import { getAllOperators } from '../services/api/pending-onboarding';
import SuggestionsDialog from '../components/suggestions/SuggestionsDialog';
import { fetchCenters, fetchDoctors } from '../services';
import { debounce } from '../utils';
import MagnifyingGlass from '../images/NavbarAndSidebar/magnifiyingGlass.svg';


const { Paragraph, Text } = Typography;
const { Option } = Select;


const HeaderComponent = ({ history, dispatch,user,comments,verticals,authToken }) => {
  const [notificationsVisible, setNotificationsVisible] = React.useState(false);
  const [notificationsLoading, setNotificationsLoading] = React.useState(false);
  const [profileModal, setProfileModal] = React.useState(false);
  const [doctorId, setDoctorId] = React.useState('');
  const [notificationsList, setNotificationsList] = React.useState([]);
  const [state, setState] = useState({
    appBarTitle: 'Doctor Registration Form',
    doctorId: null,
    docData: null,
    open: false,
    ncIdForEdit: null,
    openRegisterNetworkCenter: false,
    openChat: false,
    selectedRequestId: null,
    pendingOnboardings: [],
    requestId: null,
    showSuggestions: false,
    fetchingDoctors: false,
    fetchedDoctors: [],
    fetchingCenters: false,
    fetchedCenters: [],
    userDetails: {},
  });
  const pubnubClient = new PubNub({
    subscribeKey: config.pubnubSubscribeKey,
    publishKey: config.pubnubPublishKey,
  });


  useEffect(() => {
    if (!authToken) {
      history.push('/');
    }
    fetchAllOperators();

    pubnubClient.subscribe({
      channels: [config.notificationChannel],
      withPresence: false,
    });

    pubnubClient.addListener({
      message: (msg) => {
        console.log(msg, 'Incoming message');
        if (msg.message) {
          const messagePayload = msg.message;
          notification.info({
            key: msg.timetoken,
            message: `${messagePayload.name}: ${messagePayload.text}`,
            onClick: () => {
              if (messagePayload.requestId) {
                dispatch(setCommentOpened({ requestId: messagePayload.requestId }));
              }
            },
            duration: 4,
          });
        }
      },
    });

    return () => {
      pubnubClient.unsubscribeAll();
    };
  }, [authToken, dispatch, history ]);

  const fetchAllOperators = () => {
    getAllOperators()
      .then((resp) => {
        if (resp.message === 'success') {
          let currentOperator;
          if (user.userId) {
            currentOperator = resp.operators.find((o) => o.operatorId === user.userId);
          }
          setState((prevState) => ({
            ...prevState,
            userDetails: resp.userDetails,
          }));
          dispatch(setOperators({
              operators: resp.operators,
              currentOperator,
              sponsors: resp.sponsors,
              verticals: resp.verticals,
              userDetails: resp.userDetails,
              cities: resp.cities,
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSearchDoctor = (value) => {
    setState((prevState) => ({ ...prevState, fetchingDoctors: true }));
    if (value.trim() === '') {
      setState((prevState) => ({
        ...prevState,
        fetchedDoctors: [],
        fetchingDoctors: false,
      }));
      return;
    }
    fetchDoctors(value)
      .then((res) => {
        setState((prevState) => ({
          ...prevState,
          fetchedDoctors: res.result.map((ele) => ({
            key: ele.doctorId,
            label: `${ele.doctorName}-${ele.verticalName}`,
            ...ele,
          })),
        }));
      })
      .finally(() => {
        setState((prevState) => ({ ...prevState, fetchingDoctors: false }));
      });
  };

  const onSearchCenter = (value) => {
    setState((prevState) => ({ ...prevState, fetchingCenters: true }));
    if (value.trim() === '') {
      setState((prevState) => ({
        ...prevState,
        fetchedCenters: [],
        fetchingCenters: false,
      }));
      return;
    }
    fetchCenters(value)
      .then((res) => {
        setState((prevState) => ({
          ...prevState,
          fetchedCenters: res.result.map((ele) => ({
            key: ele.centerId,
            label: ele.title,
            locality: ele.locality,
          })),
        }));
      })
      .finally(() => {
        setState((prevState) => ({ ...prevState, fetchingCenters: false }));
      });
  };
  const debouncedFetchHealthCenters = useCallback(debounce(onSearchCenter, 600), []);
  const debouncedFetchDoctors = useCallback(debounce(onSearchDoctor, 600), []);


  const openSuggestions = () => {
    console.log('Open Suggestions');
    setState((prevState) => ({ ...prevState, showSuggestions: true }));
  };

  const closeSuggestions = () => {
    console.log('Close Suggestions');
    setState((prevState) => ({ ...prevState, showSuggestions: false }));
  };

  const { fetchingDoctors, fetchedDoctors, fetchingCenters, fetchedCenters, userDetails } = state;


  const handleClick = (e) => {
    switch (e.key) {
      case '1':
        history.push('/home');
        break;
      case '2':
        history.push('/doctor-profile/new');
        break;
      case '3':
        showModal();
        break;
      case '4':
        history.push('/center-profile/new');
        break;
      case '5':
        history.push('/on-the-fly');
        break;
      case 'logout':
        dispatch(logoutUser(history));
        break;
      default:
        break;
    }
  };
  const getNotifications = () => {
    if (notificationsList.length > 0) {
      // The list was open. It is getting closed now. Reset the list
      setNotificationsList([]);
      return;
    }
    setNotificationsLoading(true);
    getNotificationList()
      .then((result) => {
        const list = result.results;
        setNotificationsList(list);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setNotificationsLoading(false);
      });
  };
  const onPopoverVisibleChange = (visible) => {
    setNotificationsVisible(visible);
    if (!visible) {
      setNotificationsList([]);
      return;
    }
  };
  const getColorForNotificationType = (type) => {
    switch (type) {
      case 'ops':
        return '#d4380d';
      case 'network':
        return '#096dd9';
      default:
        return '#595959';
    }
  };
  const openComments = (notification) => () => {
    if (notification.requestId) {
      setNotificationsVisible(false);
      dispatch(
        setCommentOpened({
          requestId: notification.requestId,
        })
      );
      // dispatch(setPoOpenChat(false));
    }
  };
  const showModal = () => {
    setProfileModal(true);
    setDoctorId('');
  };

  const handleOk = (e) => {
    setProfileModal(false);
    history.push(`/doctor-profile/${this.state.doctorId}`);
  };

  const handleCancel = (e) => {
    setProfileModal(false);
  };
  return (
  
    <>
      {/* Top bar */}
      <Layout.Header style={{
        position: 'sticky', width: '100%' , top: 0,left:0,right:0, zIndex: 1000, backgroundColor: '#001529', padding: '0 16px' }}>
        <Menu
          theme="dark"
          mode="horizontal"
          selectable={false}
          style={{ lineHeight: '64px'}}
        >
          <Menu.Item
            key="1"
            onClick={() => history.push('/home')}
            style={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#FFFFFF',
              padding: '0 0 0 0 '
            }}
          >
            Network Dashboard
          </Menu.Item>
          <Menu.Item style={{ width: '200px' }}>
            <Select
              showSearch
              style={{ width: '100%' }}
              dropdownMatchSelectWidth={false}
              notFoundContent={fetchingDoctors ? <Spin size="small" /> : null}
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              placeholder={
                <div>
                  <img
                    src={MagnifyingGlass}
                    alt="magnifying glass"
                    style={{ width: '15px', height: '15px' }}
                  />
                  Search Doctor
                </div>
              }
              onSearch={debouncedFetchDoctors}
              onChange={(e) => {
                console.log(e);
                history.push(`/doctor-profile/${e}`);
              }}
            >
              {fetchedDoctors.map((d) => (
                <Option key={d.key}>
                  <Row>{d.label}</Row>
                  <Row>
                    {d.centers.map((center) => (
                      <Col key={center.centerId}>
                      <Text code>{`${center.hospitalName}, ${center.locality}`}</Text>
                        <Text code>
                          Is Active - {center.isActive ? 'Yes' : 'No'}
                        </Text>
                        <Text code>Status - {center.status}</Text>
                      </Col>
                    ))}
                  </Row>
                </Option>
              ))}
            </Select>
          </Menu.Item>
          <Menu.Item style={{ width: '200px' }}>
            <Select
              showSearch
              style={{ width: '100%' }}
              dropdownMatchSelectWidth={false}
              notFoundContent={fetchingCenters ? <Spin size="small" /> : null}
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              placeholder={
                <div>
                  <img
                    src={MagnifyingGlass}
                    alt="magnifying glass"
                    style={{ width: '15px', height: '15px' }}
                  />
                  Search Center
                </div>
              }
              onSearch={debouncedFetchHealthCenters}
              onChange={(e) => {
                console.log(e);
                history.push(`/center-profile/${e}`);
              }}
            >
              {fetchedCenters.map((d) => (
                <Option key={d.key}>
                  <Col>
                    {d.label}({d.locality}){' '}
                    <Text code>Is Active - {d.isActive ? 'Yes' : 'No'}</Text>
                  </Col>
                </Option>
              ))}
            </Select>
          </Menu.Item>
          <Menu.Item onClick={openSuggestions}>Suggestions</Menu.Item>
        </Menu>
        <SuggestionsDialog
          isOpen={state.showSuggestions}
          closeSuggestions={closeSuggestions}
          verticals={verticals}
        />
        <Menu
          theme="dark"
          mode="horizontal"
          onClick={handleClick}
          selectable={false}
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            lineHeight: '64px',
            backgroundColor: '#001529', // Ensure consistent styling with the header
            padding: '0 16px', // Optional: Adds padding
          }}
        >

          <Menu.Item key="notifications" onClick={getNotifications}>
            <Popover
              placement="bottom"
              title="Notifications"
              autoAdjustOverflow={false}
              visible={notificationsVisible}
              onVisibleChange={onPopoverVisibleChange}
              overlayStyle={{ overflowY: 'scroll', height: '500px' }}
              content={
                <List
                  loading={notificationsLoading}
                  dataSource={notificationsList}
                  renderItem={(item) => (
                    <List.Item onClick={openComments(item)}>
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            style={{
                              backgroundColor: getColorForNotificationType(
                                item.userType
                              ),
                            }}
                            size="large"
                          >
                            {item.userName.substring(0, 1)}
                          </Avatar>
                        }
                        title={`${item.networkCenter} - ${item.doctorName}`}
                        description={
                          <>
                            <Paragraph style={{ margin: 0 }}>
                              {item.content}
                            </Paragraph>
                            <Text>{moment().to(item.timestamp * 1000)}</Text>
                          </>
                        }
                      />
                    </List.Item>
                  )}
                />
              }
              trigger="click"
            >
              <img
                src={notificationIcon}
                alt="notification"
                style={{ width: '20px', height: '20px' }}
              />
            </Popover>
          </Menu.Item>
          <Menu.Item key="logout">
            <img
              src={logoutIcon}
              alt="logout"
              style={{ width: '20px', height: '20px' }}
            />
          </Menu.Item>


        </Menu>
      </Layout.Header>
    </>

  );
};

const mapStateToProps = (state) => ({
  comments: state.comments,
  user: state.user,
  verticals: state.info.verticals,
  authToken: state.user.authToken,
});

export default withRouter(connect(mapStateToProps)(HeaderComponent));
